import { ERROR_CODE } from './config';

// 生成traceId
function generateTraceId() {
  const { v4: uuidv4 } = require('uuid');
  const uuid = uuidv4();
  const cleanUuid = uuid.replace(/-/g, '');
  const suffix = cleanUuid.slice(-17).toLowerCase();
  return 'i' + suffix;
}

// 从 cookie 中获取指定名称的值
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }
  return null;
}

// 请求拦截器
export const requestInterceptor = (config) => {
  // 从 localStorage 获取用户信息
  try {
    const userInfo = JSON.parse(localStorage.getItem('user_info') || '{}');
    if (userInfo?.tokenName && userInfo?.tokenValue) {
      config.headers[userInfo.tokenName] = userInfo.tokenValue;
    }
    config.headers['x-traceId'] = generateTraceId();
  } catch (error) {
    console.error('Error parsing user info:', error);
  }
  
  // 从 cookie 中读取 jwtToken 并设置到 header
  try {
    const jwtToken = getCookie('jwtToken');
    if (jwtToken) {
      config.headers['enjoy-token'] = jwtToken;
    }
  } catch (error) {
    console.error('Error reading jwtToken from cookie:', error);
  }
  
  return config;
};

// 请求错误拦截器
export const requestErrorInterceptor = (error) => {
  return Promise.reject(error);
};

// 响应拦截器
export const responseInterceptor = (response) => {
  const { data, status } = response;
  
  if (status === ERROR_CODE.SUCCESS) {
    // 检查业务状态码
    if (data.code === 100001) {
      // 清除用户信息
      localStorage.removeItem('user_info');
      localStorage.removeItem('apple_user');
      localStorage.removeItem('apple_token');
      console.log('🔑 用户未登录，清除本地存储');
      // 不再自动跳转，让组件自己处理
      return Promise.reject(new Error('User not logged in'));
    }
    return data;
  }
  
  return Promise.reject(new Error('Request failed'));
};

// 响应错误拦截器
export const responseErrorInterceptor = (error) => {
  const { response, config } = error;
  
  // 检查是否已经重试过
  const retryCount = config.__retryCount || 0;
  const maxRetries = config.maxRetries || 0;
  
  console.error('请求失败:', {
    url: config?.url,
    method: config?.method,
    status: response?.status,
    retryCount,
    maxRetries,
    error: error.message
  });
  
  if (response) {
    switch (response.status) {
      case ERROR_CODE.UNAUTHORIZED:
        // 处理401错误
        console.error('未授权访问，请重新登录');
        localStorage.removeItem('user_info');
        localStorage.removeItem('apple_user');
        localStorage.removeItem('apple_token');
        break;
      case ERROR_CODE.FORBIDDEN:
        // 处理403错误
        console.error('没有权限访问');
        break;
      case ERROR_CODE.NOT_FOUND:
        // 处理404错误 - 跳转到404页面
        console.error('资源不存在，跳转到404页面');
        if (typeof window !== 'undefined') {
          window.location.href = '/404';
        }
        break;
      case ERROR_CODE.SERVER_ERROR:
        // 处理500错误 - 跳转到404页面
        console.error('服务器错误，跳转到404页面');
        if (typeof window !== 'undefined') {
          window.location.href = '/404';
        }
        break;
      default:
        console.error('请求错误:', error);
    }
  } else {
    // 处理网络错误
    console.error('网络错误，请检查您的网络连接');
  }
  
  // 直接返回错误，不进行重试
  return Promise.reject(error);
}; 


